import { Loader } from '~shared/ui/atoms/Loader';
import type { Ref } from '~types/Ref';

import type { ButtonSize } from './styles';
import { Button, IconWrapper, Text } from './styles';

export type ButtonBaseProps = {
	type?: 'button' | 'submit' | 'reset';
	children?: React.ReactNode;
	iconLeft?: React.ReactNode;
	className?: string;
	text?: React.ReactNode;
	size?: ButtonSize;
	width?: number;
	fullWidth?: boolean;
	shadowless?: boolean;
	disabled?: boolean;
	loading?: boolean;
	onClick?: () => void;
};

export const ButtonBase = ({
	type = 'button',
	children,
	className,
	text,
	size = 'large',
	width,
	fullWidth,
	shadowless,
	disabled,
	loading,
	iconLeft,
	onClick,
	ref,
}: ButtonBaseProps & Ref<HTMLButtonElement>) => (
	<Button
		type={type}
		className={`${loading ? 'loading' : ''} ${shadowless ? 'shadowless' : ''} ${
			className || ''
		}`}
		size={size}
		width={width}
		fullWidth={fullWidth}
		disabled={disabled}
		onClick={onClick}
		ref={ref}
	>
		{loading ? (
			<Loader size={24} />
		) : (
			<>
				{iconLeft && <IconWrapper size={size}>{iconLeft}</IconWrapper>}
				{text && <Text size={size}>{text}</Text>}
				{children}
			</>
		)}
	</Button>
);

ButtonBase.displayName = 'ButtonBase';
